import React, { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "react-bootstrap";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { useSelector } from "react-redux";

const ModalSettings = (props) => {
  const { t } = useTranslation();
  const { show, closeModal } = props;
  const { ReduxUserIdColidee } = useSelector((state) => state.ReduxUser);

  return (
    <Modal size="xl" show={show} onHide={closeModal}>
      {/* <pre>{JSON.stringify(crop, null, 4)}</pre> */}
      <Modal.Header closeButton>
        <Modal.Title> {t("public.pageChoixInstance.modalTitle")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          {t("public.pageChoixInstance.modalContentExplicationPart1")}{" "}
          <a
            href={"https://colidee.com/profile/" + ReduxUserIdColidee}
            target={"_blank"}
            style={{ color: "#F33" }}
            rel="noreferrer"
          >
            {t("public.pageChoixInstance.modalContentExplicationPart2")}
          </a>
          <br />
          <br />
          {t("public.pageChoixInstance.modalContentExplicationPart3")}
          <a
            href={"https://ethics-group.com/outilSuppressionCompte"}
            style={{ color: "#F33" }}
            rel="noreferrer"
            target="_blank"
          >
            {t("public.pageChoixInstance.modalContentExplicationPart4")}
          </a>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalSettings;
